<template>

  <section id="hero" class="d-flex align-items-center">
      <div class="container">

        <div class="row">

          <div class="col-lg-5 pt-5 pt-lg-0 order-2 order-lg-1 d-flex flex-column justify-content-center">

            <h1 class="pb-2" data-aos="fade-up">Cuidamos da sua contabilidade para você focar no crescimento do seu negócio.</h1>

            <div class="col-lg-12 check-item" data-aos="fade-up" data-aos-delay="150">
              <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Planos de acordo com sua necessidade
            </div>

            <div class="col-lg-12 check-item" data-aos="fade-up" data-aos-delay="150">
              <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Soluções contábeis personalizadas para sua empresa
            </div>

            <div class="col-lg-12 check-item" data-aos="fade-up" data-aos-delay="150">
              <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Regularização completa com economia máxima de impostos
            </div>

            <div class="col-lg-12 check-item" data-aos="fade-up" data-aos-delay="150">
              <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Consultoria especializada para cada etapa do seu crescimento
            </div>
            <!--
            <div class="col-lg-12 check-button" data-aos="fade-up" data-aos-delay="150">
              <a href="#planos" class="btn-get-started scrollto">Conheça nossos planos</a>
            </div>
            -->
          </div>

          <div class="col-lg-7 order-1 order-lg-2 hero-img" data-aos-delay="200">
            <img src="../assets/img/sigame-hero4.jpg" class="img-fluid animated"  alt="" >
          </div>

        </div>

      </div>
  </section>

</template>

<script>
export default {
  name: 'HeroComp'
}
</script>

<style scoped lang="scss">

#hero {
  background-color: $hero-bg-color;
  padding-top: 0;
  height: 98vh;
  padding: 25vh 1vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#hero h1 {
  margin: 0 0 10px 0;
  font-size: 45px;
  font-weight: 700;
  line-height: 50px;
  color: $color-base;
}

#hero img {
  border-radius: 2%;
  width: 98%;
  box-shadow: 0 0 29px 0 rgba(68, 88, 144, 0.12);
  transition: box-shadow 0.3s ease;
}

#hero .check-item {
  text-align: left;
}

#hero .check-button {
  padding-top: 10px;
}

#hero .btn-get-started {
  font-family: $font-family-base;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 1px;
  display: inline-block;
  padding: 10px 30px;
  border-radius: 50px;
  transition: 0.5s;
  color: $btn-default-bg;
  border: 2px solid $btn-default-bg;
  margin: 30px 0 0 0;
  text-decoration: none;
}

#hero .btn-get-started:hover {
  background: $btn-default-bg-hover;
  color: $btn-default-color;
}

#hero .animated {
  animation: up-down 20s ease-in-out infinite alternate-reverse both;
}

@media (max-width: 1322px) {
  #hero {
    height: auto;
    padding-top: 15vh;
    padding-bottom: 5vh;
  }
  #hero h1 {
    font-size: 38px;
    line-height: 42px;
    text-align: center;
    margin-top: -20px;
  }
  #hero .hero-img img {
    width: 85%;
    margin-top: -20px;
  }
}

@media (max-width: 991px) {
  #hero {
    height: auto;
    padding-top: 5vh;
    padding-bottom: 5vh;
  }
  #hero h1 {
    font-size: 32px;
    line-height: 36px;
    text-align: center;
  }
  #hero .hero-img img {
    width: 80%;
  }
}

@media (max-width: 768px) {
  #hero {
    height: auto;
    padding-top: 5vh;
    padding-bottom: 5vh;
  }
  #hero h1 {
    font-size: 28px;
    line-height: 32px;
    text-align: center;
  }
  #hero .check-item {
    text-align: center;
  }
  #hero .hero-img img {
    width: 70%;
  }
  #hero .btn-get-started {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

@media (max-width: 575px) {
  #hero {
    height: auto;
    padding-top: 5vh;
    padding-bottom: 5vh;
  }
  #hero h1 {
    font-size: 24px;
    line-height: 28px;
    text-align: center;
  }
  #hero .check-item {
    text-align: center;
  }
  #hero .hero-img img {
    width: 60%;
  }
}

@keyframes up-down {
  0% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(-10px);
  }
}
</style>
